import { H4, P } from '../../../../../../AbstractElements';
import { OlivaLogin, OlivaLoginText } from '../../../../../../Utils/Constants';
import StaticModalForm from '../../../StaticModal/StaticModalForm';

type propsType = {
    toggle: () => void;
}

function Modal2Body ({ toggle }: propsType) {
    return (
        <div className="modal-toggle-wrapper">
            <H4>{OlivaLogin}</H4>
            <P>{OlivaLoginText}</P>
            <StaticModalForm toggle={toggle} />
        </div>

    )
}
export default Modal2Body;